import * as constants from './constants'

export const createVehicle = (tag, make, model, color, country, state, isRentalCar, rentalExpiryDate, onSuccess) => ({
    type: constants.CREATE_VEHICLE,
    tag,
    make,
    model,
    color,
    country,
    state,
    isRentalCar,
    rentalExpiryDate,
    onSuccess,
})

export const removeVehicle = vehicle => ({
    type: constants.REMOVE_VEHICLE,
    vehicle,
})
